import styled from 'styled-components';

export const SubIndex = styled.p`
  text-align: left;
  font-size: 16px;
  margin-bottom: 4px;

`